import { useEffect, useState } from "react";
import { getWhatsAppStatus, getWhatsAppQR, logoutWhatsApp, resetWhatsApp } from "../lib/api";
import { MessageCircle, CheckCircle2, LogOut, Loader2 } from "lucide-react";

export const WhatsAppPanel = () => {
  const [status, setStatus] = useState({ state: "connecting", connected: false, me: null, hasQr: false });
  const [qr, setQr] = useState(null);

  useEffect(() => {
    let active = true;
    const tick = async () => {
      try {
        const s = await getWhatsAppStatus();
        if (!active) return;
        setStatus(s);
        if (s.state === "qr" && s.hasQr) {
          const q = await getWhatsAppQR();
          if (active) setQr(q.qr);
        } else if (s.connected) {
          setQr(null);
        }
      } catch (e) {}
    };
    tick();
    const iv = setInterval(tick, 3000);
    return () => {
      active = false;
      clearInterval(iv);
    };
  }, []);

  const [resetting, setResetting] = useState(false);
  const handleReset = async () => {
    setResetting(true);
    try {
      await resetWhatsApp();
    } catch (e) {}
    setStatus({ state: "connecting", connected: false, me: null, hasQr: false });
    setQr(null);
    setTimeout(() => setResetting(false), 15000);
  };

  const handleLogout = async () => {
    try {
      await logoutWhatsApp();
    } catch (e) {}
    setStatus({ state: "connecting", connected: false, me: null, hasQr: false });
    setQr(null);
  };

  return (
    <div className="rounded-xl border border-slate-700 bg-slate-900/60 p-4" data-testid="whatsapp-panel">
      <div className="flex items-center gap-2 mb-3">
        <MessageCircle className="w-5 h-5 text-green-400" />
        <h3 className="font-semibold text-slate-100">WhatsApp (automat)</h3>
      </div>

      {status.connected ? (
        <div className="space-y-3" data-testid="whatsapp-connected">
          <div className="flex items-center gap-2 text-green-400 text-sm">
            <CheckCircle2 className="w-4 h-4" />
            <span>Conectat{status.me ? ` — ${status.me}` : ""}</span>
          </div>
          <p className="text-slate-400 text-sm">
            Mesajele din grupuri intră automat în aplicație. Nu trebuie să ții nimic deschis.
          </p>
          <button
            onClick={handleLogout}
            data-testid="whatsapp-logout-btn"
            className="flex items-center gap-2 text-sm text-red-400 hover:text-red-300 transition-colors"
          >
            <LogOut className="w-4 h-4" /> Deconectează
          </button>
        </div>
      ) : qr ? (
        <div className="space-y-3 text-center" data-testid="whatsapp-qr">
          <p className="text-slate-300 text-sm text-left">
            Scanează codul cu telefonul: <b>WhatsApp → Setări → Dispozitive conectate → Conectează un dispozitiv</b>
          </p>
          <img
            src={qr}
            alt="QR WhatsApp"
            className="mx-auto rounded-lg bg-white p-2"
            style={{ width: 240, height: 240 }}
            data-testid="whatsapp-qr-img"
          />
          <p className="text-slate-500 text-xs">Codul se reîmprospătează automat la câteva secunde.</p>
        </div>
      ) : (
        <div className="flex items-center gap-2 text-slate-400 text-sm" data-testid="whatsapp-connecting">
          <Loader2 className="w-4 h-4 animate-spin" />
          <span>{status.state === "offline" ? "Serviciul WhatsApp pornește…" : "Se conectează…"}</span>
        </div>
      )}
      {!status.connected && !qr && (
        <button
          onClick={handleReset}
          disabled={resetting}
          data-testid="whatsapp-reset-btn"
          className="mt-3 text-sm text-amber-400 hover:text-amber-300 disabled:opacity-50 transition-colors"
        >
          {resetting ? "Se generează un cod QR nou…" : "Nu apare codul QR? Resetează conexiunea"}
        </button>
      )}
    </div>
  );
};
